import React, { useEffect, useState } from "react";
import { Card, Col, Nav, Row, Tab, Table } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { Stepper } from "./Stepper";
import { t } from "i18next";
import { useLocation } from "react-router";
import { ProductsService } from "../../service";
import { IProducts } from "../../dto/IProducts";
import { ErrorToast, SuccessToast } from "../../../../shared/toasters/toasters";
import { ProductsListView } from "../../components/ProductsListView";
import {
  formatDate,
  getCorrectLanguage,
} from "../../../../shared/functions/Functions";
import { CustomImageHandler } from "../../../../shared/components/CustomImageHandler";
import { useDispatch, useSelector } from "react-redux";
import { IAllStates } from "../../../../store/rootReducer";
import { EnumService } from "../../../../store/enums/enumService";
import enumsSlice from "../../../../store/enums/enumsRedux";

export const StepBase = () => {
  const location: any = useLocation();
  const [products, setProducts] = useState<IProducts[]>();
  const [product, setProduct] = useState<IProducts>();
  const dispatch = useDispatch();
  const { translationLanguageEnum } = useSelector(
    (state: IAllStates) => state.enums
  );
  console.log(translationLanguageEnum);
  interface LanguageRequirement {
    language: string;
    title: boolean;
    subtitle: boolean;
    links: boolean;
    photos: boolean;
    documents: boolean;
    videos: boolean;
  }

  interface Requirements {
    articleNumber: boolean;
    sapId: boolean;
    pharmaCode: boolean;
    category: boolean;
    brand: boolean;
    sourceUrl: boolean;
    languages: LanguageRequirement[];
  }

  const [requirements, setRequirements] = useState<Requirements>({
    articleNumber: false,
    sapId: false,
    pharmaCode: false,
    category: false,
    brand: false,
    sourceUrl: false,
    languages: [],
  });

  useEffect(() => {
    if (!translationLanguageEnum) return;

    const updatedLanguages = translationLanguageEnum.map((lang: string) => ({
      language: lang,
      title: false,
      subtitle: false,
      links: false,
      photos: false,
      documents: false,
      videos: false,
    }));

    setRequirements((prev) => ({
      ...prev,
      languages: updatedLanguages,
    }));
  }, [translationLanguageEnum]);

  const toggleCheckbox = (field: string) => {
    setRequirements((prev: any) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const toggleLangField = (languageCode: string, field: string) => {
    const updated = [...requirements.languages];
    const langIndex = updated.findIndex(
      (lang) => lang.language === languageCode
    );
    if (langIndex === -1) return;

    (updated as any)[langIndex][field] = !(updated as any)[langIndex][field];

    setRequirements((prev: any) => ({
      ...prev,
      languages: updated,
    }));
  };
  const selectedProducts = JSON.parse(
    localStorage.getItem("selectedProducts") as string
  );
  const selectChangeHandler = (selectedProduct: IProducts) => {
    setProduct(selectedProduct);
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    const filteredArray = selectedProducts?.filter(
      (item: number) => item != product?.id
    );
    console.log("🧾 Checked requirements:", {
      fromProduct: product?.id,
      toProducts: filteredArray,
      ...requirements,
    });

    ProductsService.copyManageBase({
      fromProduct: product?.id,
      toProducts: filteredArray,
      ...requirements,
    })
      .then((response) => {
        SuccessToast(`${t("toasts.successfully_added")}`);
      })
      .catch((error) => ErrorToast(error));
  };
  useEffect(() => {
    if (selectedProducts?.length > 1) {
      const checkedValuesAsStrings = selectedProducts.map(String);
      ProductsService.getManageProductsByIds({ ids: checkedValuesAsStrings })
        .then((response) => {
          setProducts(response);
        })
        .catch((error) => ErrorToast(error));
    }
  }, []);
  useEffect(() => {
    EnumService.getEnums().then((data) => {
      dispatch(enumsSlice.actions.setEnums(data));
    });
  }, []);

  return (
    <>
      <div className="card">
        <Helmet>
          <title>{t("manage.products_manage_base_data")}</title>
        </Helmet>
        <div className="">
          <Stepper step={"BASE_DATA"}></Stepper>
          <>
            {product?.id ? (
              <>
                <div className="mt-3">
                  <div className="card-header d-flex align-items-center justify-content-between my-0">
                    <h4 className="card-title mb-0">
                      {t("manage.selected_product")}
                    </h4>
                    <button
                      className="btn btn-secondary ms-2"
                      onClick={(e) => handleSubmit(e)}
                    >
                      {t("global_v2.copy")}
                    </button>
                  </div>

                  <div className="card-body">
                    <Table className="align-middle table-nowrap ">
                      <thead className="table-light">
                        <tr>
                          <th scope="col">{`${t("global.id")}`}</th>
                          <th scope="col">{`${t("global.aenCode")}`}</th>
                          <th scope="col">{`${t("products.product")}`}</th>
                          <th scope="col">{`${t("products.category")}`}</th>
                          <th scope="col">{`${t("products.createdAt")}`}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr key={product?.id}>
                          <td>
                            <span>#{product?.id}</span>
                          </td>
                          <td>
                            <span className="text-dark">
                              {product?.eanCode ?? "-"}
                            </span>
                          </td>
                          <td>
                            <span className="d-flex justify-content-start">
                              <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 me-3">
                                  <div className="avatar-sm bg-light rounded p-1">
                                    <CustomImageHandler
                                      path={product?.productPictures?.[0]?.path}
                                      alt="Product"
                                      classes="avatar-xs h-100 w-100"
                                    />
                                  </div>
                                </div>
                                <div className="flex-grow-1">
                                  <h5 className="fs-14 mb-1">
                                    <>{product?.title ?? "-"}</>
                                  </h5>
                                </div>
                              </div>
                            </span>
                          </td>

                          <td>
                            {(product?.category as any)?.title ??
                              "Without category"}
                          </td>
                          <td>{formatDate((product as any)?.createdAt)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <div
                    className="row"
                    style={{ display: "flex", alignItems: "end" }}
                  >
                    <div className="col-md-6">
                      <Tab.Container
                        defaultActiveKey={translationLanguageEnum[0]}
                      >
                        <Nav variant="tabs">
                          {requirements.languages.map((lang: any) => (
                            <Nav.Item key={lang.language}>
                              <Nav.Link eventKey={lang.language}>
                                {getCorrectLanguage(lang?.language, t)}
                              </Nav.Link>
                            </Nav.Item>
                          ))}
                        </Nav>
                        <Tab.Content className="mt-3">
                          {requirements.languages.map(
                            (lang: any, langIndex) => (
                              <Tab.Pane
                                eventKey={lang.language}
                                key={lang.language}
                              >
                                <div className="row">
                                  {[
                                    "title",
                                    "subtitle",
                                    "links",
                                    "photos",
                                    "documents",
                                    "videos",
                                  ].map((field) => (
                                    <div className="col-md-6" key={field}>
                                      <div className="form-check my-1">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`${lang.language}-${field}`}
                                          checked={lang[field]}
                                          onChange={() =>
                                            toggleLangField(
                                              lang.language,
                                              field
                                            )
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`${lang.language}-${field}`}
                                        >
                                          {/* {field} */}
                                          {`${t(`mapping.${field}`)}`}
                                        </label>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </Tab.Pane>
                            )
                          )}
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                    <div className="col-md-6">
                      {(() => {
                        const fields = [
                          "articleNumber",
                          "sapId",
                          // "pharmaCode",
                          "category",
                          "brand",
                          "sourceUrl",
                        ];

                        const chunkArray = (arr: string[], size: number) => {
                          const chunks = [];
                          for (let i = 0; i < arr.length; i += size) {
                            chunks.push(arr.slice(i, i + size));
                          }
                          return chunks;
                        };

                        const fieldChunks = chunkArray(fields, 3);

                        return (
                          <>
                            <div className="row">
                              {fieldChunks.map((chunk, index) => (
                                <div
                                  className="col-md-6"
                                  key={index}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "end",
                                  }}
                                >
                                  {chunk.map((field) => (
                                    <div
                                      key={field}
                                      className="form-check my-1"
                                    >
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={field}
                                        checked={(requirements as any)[field]}
                                        onChange={() => toggleCheckbox(field)}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={field}
                                      >
                                        {t(`products.${field}`)}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              ))}
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <p>{t("manage.no_source_product")}</p>
            )}
          </>
          <>
            <div className="card-header my-0">
              <h4 className="card-title mb-0">
                {t("manage.list_of_products")}
              </h4>
            </div>
            <div className="card-body">
              <Table className="align-middle table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>{t("global.select")}</th>
                    <th scope="col">{`${t("global.id")}`}</th>
                    <th scope="col">{`${t("global.aenCode")}`}</th>
                    <th scope="col">{`${t("products.product")}`}</th>
                    <th scope="col">{`${t("products.category")}`}</th>
                    <th scope="col">{`${t("products.createdAt")}`}</th>
                  </tr>
                </thead>
                <tbody>
                  {products?.map((product: any) => (
                    <tr key={product?.id}>
                      <td>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="format"
                          id={`flexRadioDefault${product?.id}`}
                          onChange={() => selectChangeHandler(product)}
                        />
                      </td>
                      <td>
                        <span>#{product?.id}</span>
                      </td>
                      <td>
                        <span className="text-dark">
                          {product?.eanCode ?? "-"}
                        </span>
                      </td>
                      <td>
                        <span className="d-flex justify-content-start">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 me-3">
                              <div className="avatar-sm bg-light rounded p-1">
                                <CustomImageHandler
                                  path={product?.productPictures?.[0]?.path}
                                  alt="Product"
                                  classes="avatar-xs h-100 w-100"
                                />
                              </div>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="fs-14 mb-1">
                                <>{product?.title ?? "-"}</>
                              </h5>
                            </div>
                          </div>
                        </span>
                      </td>

                      <td>
                        {(product?.category as any)?.title ??
                          "Without category"}
                      </td>
                      <td>{formatDate(product?.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </>
        </div>
      </div>
    </>
  );
};
